// @flow

import styled from "@emotion/styled";
import { css } from "@emotion/react";
import { ifProp } from "styled-tools";

import * as spacing from "src/styles/constants/spacing";
import * as colors from "src/styles/constants/colors";
import { colors as oldColors } from "src/styles/constants";
import { fontSize } from "src/styles/constants/size";

export const ChatHistory = styled.div`
  overflow-y: auto;
  background: transparent;
  flex: 1;
  font-size: ${fontSize.base};
  isolation: isolate;

  ${(props) =>
    props.flexEnd
      ? css`
          display: flex;
          justify-content: flex-end;
        `
      : css``}
  :after {
    content: "";
    height: ${spacing.space_l};
    display: block;
  }
`;

export const MessageText = styled.div`
  position: relative;
  p {
    line-height: 1.43;
    letter-spacing: normal;
    color: ${oldColors.dullGrey};
  }
`;

export const MessageContent = styled.div`
  min-width: 71px;
  overflow-x: auto;
  white-space: normal;
  > div > span > p {
    margin: 4px 0px;
  }
`;

export const MessageBody = styled.div`
  display: inline;
  user-select: text;
  code {
    font-family: monospace, monospace !important;
  }

  > span > ol {
    margin: 0px;
  }
`;

export const FileInfo = styled.div`
  align-items: center;
  flex-flow: row;
  > svg {
    margin-left: -0.3em;
  }
  > div:nth-of-type(2) {
    margin-left: 0.3em !important;
  }
`;

export const NewMenu = styled.div`
  position: absolute;
  right: 20px;
  top: ${(props) => props.verticalOffset ?? "-15px"};
  display: flex;
  svg {
    cursor: pointer;
  }
`;

export const MenuOption = styled.div`
  padding: 8px 4px;
  border-radius: 3px;
  margin-left: 3px;
  border: solid 1px ${colors.grey3};
  background-color: ${colors.brightLight};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Reply = styled(MenuOption)`
  position: relative;
  height: 30px;
  width: 30px;
  padding: 0px;
  top: -2px;
`;

export const Forward = styled(MenuOption)`
  position: relative;
  height: 30px;
  width: 30px;
  padding: 0px;
  top: -2px;
`;

export const Delete = styled(MenuOption)`
  height: 30px;
  width: 30px;
  position: relative;
  top: -2px;
  cursor: pointer;
  > img {
    height: 15px;
  }
`;

export const Start = styled(MenuOption)`
  color: ${colors.active};
  font-size: ${fontSize.small};
  position: relative;
  top: -2px;
  cursor: pointer;
  height: 30px;
`;

export const EmailReply = styled(MenuOption)`
  position: absolute;
  right: 181px;
  top: -2px;
  cursor: pointer;
  padding: 0 0.6em;
  white-space: nowrap;
  height: 30px;
  max-width: 90px;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const EmailForward = styled(EmailReply)`
  right: 276px;
  max-width: 120px;
`;

export const Submenu = styled.div`
  background: transparent;
  border: none;
  position: absolute;
  top: 10px;
  right: -4px;
`;

export const EmailReplyTo = styled.div`
  padding-bottom: 0.8em;
  position: relative;
  background: ${ifProp(
    "isCurrentUser",
    colors.currentUserHighlight,
    colors.grey0,
  )};
  > div {
    background: ${ifProp(
      "isCurrentUser",
      colors.currentUserHighlight,
      colors.grey0,
    )};
  }
`;

export const LoadMessageMarker = styled.div`
  width: 100%;
  height: 30px;
  background: ${colors.secondary};
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${colors.brightLight};
  font-weight: 500;
`;

export const MentionedUser = styled.span`
  color: ${colors.active};
  > span,
  > span > span {
    font-size: 0.88rem;
    font-weight: normal;
    color: ${colors.active};
  }
`;

export const ChatGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
